import React from 'react';
import { Link } from 'gatsby';
import RichText from "./richText";
import Fade from 'react-reveal/Fade';
import { linkResolver } from '../utils/linkResolver';

class QAComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openQuestions: [],
      data: [],
    };
  }

  showAnswer = answer => {
    let newArr = this.state.openQuestions;
    newArr.push(answer);
    this.setState({
      openQuestions: newArr,
    });
  };

  hideAnswer = answer => {
    let newArr = this.state.openQuestions;
    newArr.splice(newArr.indexOf(answer), 1);
    this.setState({
      openQuestions: newArr,
    });
  };

  render() {
    let self = this;
    let props = this.props;
    const { passedStyle } = this.props;

    return (
      <div className={passedStyle ? props.styleProps : 'quick-questions'}>
        <div className={passedStyle ? props.styleInner : "quick-questions__inner"}>
          <Fade left distance="4rem">
            <img src={props.dotGrid}
              alt=""
              className={passedStyle ? props.dotGrid : "quick-questions__dot-grid"} />
          </Fade>

          <h2 className="quick-questions__heading">{props.heading}</h2>

          {props.data ? (
            <ul className="quick-questions__list">
              {props.data.map(function (question, index) {
                return (
                  <li
                    key={index}
                    className={
                      self.state.openQuestions.includes(index)
                        ? 'is-open'
                        : null
                    }
                  >
                    <header className="quick-questions__header">
                      <div
                        className="quick-questions__question"
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          self.state.openQuestions.includes(index)
                            ? self.hideAnswer(index)
                            : self.showAnswer(index)
                        }
                        onKeyPress={() =>
                          self.state.openQuestions.includes(index)
                            ? self.hideAnswer(index)
                            : self.showAnswer(index)
                        }
                      >
                        <span>
                          {question.q_a
                            ? question.q_a.question[0].text
                            : ''}
                        </span>

                        <button className="quick-questions__toggle">
                          <i className="quick-questions__arrow"></i>
                        </button>
                      </div>
                    </header>

                    <Fade top distance="2rem">
                      <div
                        className="quick-questions__content"
                        id={
                          self.state.openQuestions.includes(index)
                            ? 'show-ans'
                            : 'hide-ans'
                        }
                      >
                        <div className="quick-questions__answer">
                          {question.q_a
                            ? <RichText render={question.q_a.answer} linkResolver={linkResolver} /> : ''}
                        </div>
                      </div>
                    </Fade>
                  </li>
                );
              })}
            </ul>
          ) : null}

          <div className={passedStyle ? props.medFinderLine : 'quick-questions__line'}> </div>
          <div className="quick-questions__help">
            <RichText render={props.faq_help_text} linkResolver={linkResolver} />
          </div>

          {props.buttonLink && props.buttonText && (
            <div
              className={
                passedStyle
                  ? props.medFinderButtonClass
                  : 'quick-questions__button'
              }
            >
              <Link
                to={`/faq/${props.buttonLink._meta.uid}/`}
                state={{ path: `${props.buttonLink._meta.uid}` }}
                className="button button--primary quick-questions__link-to-faq-button"
              >
                {props.buttonText}
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default QAComponent;
